import {TheCrypt} from "../../TheCrypt";
import {SpriteCollector} from "./SpriteCollector";
import {SpineTween} from "@nolimitcity/slot-game/bin/animation/SpineTween";
import {TimelineLite, TweenLite} from "gsap";

export class MSymbolCollector extends SpriteCollector {

    constructor(id: number, container: PIXI.Container) {
        super(id, container);
    }

    public hide(): void {
        this.alpha = 0;
    }

    public activate(): TimelineLite {
        this.isActive = true;
        this._step = Math.max(0, this._step);
        return new TimelineLite().add([
            new SpineTween(this._spine!, 0, this._step.toString()),
            ()=>{this.parent.addChild(this);}
            ]);
    }

    public show(name: string, isRestore: boolean = false): TimelineLite {
        const tl: TimelineLite = super.show(name, isRestore);
        let animationName: string = "base";
        this._isActive = false;
        this._step = 0;
        this._spine!.skeleton.setSkinByName(`M${this._id}`);
        tl.add([
            () => {
                this.addChild(this._spine!);
            },
            new SpineTween(this._spine!, 0, "popup")
        ]);
        tl.add(() => {
            this._spine!.state.setAnimation(0, animationName, true)
        });
        return tl;
    }

    public updateStatesOnRestore(): void {
        const sideBarProgress: number = TheCrypt.model.data.dragonSideReel[0];
        let animationName: string = "base";
        this._step = TheCrypt.model.sideBarProgress[6 - this._id];
        this._step = Math.max(0, this._step);
        this._isActive = (sideBarProgress > ((6 - this.id) * 4 - 1));
        if (this._step < this._barNum && this._step > 0) {
            animationName = "0";
        }
        if (this._isActive) {
            this._isActive = !(this._step === this._barNum);
            animationName = (this._step === this._barNum ? "wild" : this._step.toString());
            this.parent.addChild(this);
        }
        this._spine!.state.setAnimation(0, animationName, true);
    }

}